import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { hashHistory } from 'react-router';

import '../css/image-gallery.css';
import '../css/main.css';

export default class PhotoGalleryComponent extends React.Component {

    componentWillMount() {
        this.props.findPhotos(this.props.view.get('card'),
            this.props.request.get('category'));
    }

    componentDidMount() {
    }

    expand() {
        this.props.expandContent();
    }

    previousPage() {
        this.props.expandContent();
        hashHistory.push("/maintenanceCard");
        this.props.pop();
    }

    returnTakePhoto() {
        hashHistory.push("/takePhoto");
    }

    thumbnails(photos) {
        let ret = [];
        if (photos) {
            return photos;
        }
        return ret;
    }

    showNote() {
        if (this.props.previousView.get('caseModel') && this.props.previousView.get('caseModel').note) {
            return <span>{this.props.previousView.get('caseModel').note}</span>;
        }
        return '';
    }

    deletePic(photoId) {
        this.props.deletePhotoById(photoId, this.props.view.get('card'),
            this.props.request.get('category'), "PRE");
    }

    render() {

        let menuToggle = (show) => {
            if (show) {
                return 'menu-hide.svg';
            } else {
                return 'menu-show.svg';
            }
        }

        let headerImage = (category) => {
            if (category === 0) {
                return "shirt.svg";
            } else
                if (category === 1) {
                    return "shorts.svg";
                }
            return 'kk25.jpg';
        }

        return (
            <div><span hidden> PhotoGalleryComponent  </span>
                <Row>
                    <div className="snapshot" style={{ marginTop: 30, marginBottom: -15 }}>
                        <Button onClick={(e) => { this.returnTakePhoto(); }}>
                            <img title='回拍照頁' alt='回拍照頁' src='return.svg' height="45" width="45" />
                        </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <h5 style={{ color: '#5371B6' }}>
                        <a alt="hide or show menus" onClick={(event) => {
                            this.expand();
                        }}><img src={menuToggle(this.props.menu.get('show'))} height="10" width="15" title="hide or show menus" alt="hide or show menus icon" />
                        </a>
                        <img alt='shorts' src={headerImage(this.props.request.get('category'))} height="30" width="30" />
                        <span className='highlight-B'>{this.props.view.get('card').code}</span> &gt;&gt;
                        清點作業管理 &gt;&gt;
                        洗前清點 &gt;&gt;&nbsp;
                        洗前拍照 &gt;&gt;&nbsp;
                    {this.props.previousView.get('caseModel').orderId}&nbsp;-&nbsp;{this.showNote()}&nbsp;
                    <a onClick={(e) => { this.returnTakePhoto() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                    </h5>
                </Row>
                <h4>洗前拍照-相片列表</h4>
                <Row>
                    {
                        this.thumbnails(this.props.view.get('photos')).map(
                            (item, index) =>
                                <Col xs={12} sm={6} key={item.id}>
                                    <a href={item.image} target="_blank">
                                        <img src={item.image} className="img-thumbnail" alt="" />
                                    </a>
                                    <div style={{ textAlign: 'center' }}>
                                        <span className="glyphicon glyphicon-trash"
                                            style={{ marginTop: 5, marginBottom: 25, fontSize: '2em', color: '#a94442', cursor: 'pointer' }}
                                            onClick={(event) => {
                                                this.deletePic(item.id);
                                            }} />
                                    </div>
                                </Col>
                        )
                    }
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PhotoGalleryComponent.jsx